import store from "../../store";
import { Route, NavigationGuardNext } from "vue-router";

import localforage from "localforage";

// Function to check if the token is expired
async function isTokenExpired() {
  const expires = await localforage.getItem<string>("expires");
  if (!expires) {
    return true;
  }

  const expirationDate = new Date(expires);
  const currentDate = new Date();

  return currentDate > expirationDate;
}

const protectRoutesUsingPermissions = (to, next) => {
  // All users can access the profile screen
  if (to.name === "profile") {
    next();
  } else if (to.matched.some((m) => m.meta.isAdmin)) {
    // "to.matched.some" allows child routes to get the meta value from their parent
    if (to.matched.some((m) => m.meta.allowDevelopers)) {
      // Protect Screens admins and developers can access
      store.dispatch("auth/checkIfUserIsAdmin", true).then((res) => {
        if (res) next();
        else next({ name: "dashboard" });
      });
    } else {
      // Protect Screens only admins can access
      store.dispatch("auth/checkIfUserIsAdmin").then((res) => {
        if (res) next();
        else next({ name: "dashboard" });
      });
    }
  }
};

const authMiddleware = async (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) => {
  // If Not logged in, redirect to login, otherwise redirect to dashboard
  if (to.meta.guest) {
    store
      .dispatch("auth/checkIfTokenExists")
      .then(() => {
        if (to.name === "login") {
          next({ name: "dashboard" });
        } else {
          protectRoutesUsingPermissions(to, next);
          next();
        }
      })
      .catch(() => {
        protectRoutesUsingPermissions(to, next);
        next();
      });
  } else if (to.meta.authRequired) {
    const expired = await isTokenExpired();
    
    if (expired) {
      next({ name: "logout" });
    } else {
      store
        .dispatch("auth/checkIfTokenExists")
        .then(() => {
          protectRoutesUsingPermissions(to, next);
          next();
        })
        .catch(() => {
          next({ name: "login" });
        });
    }
  } else {
    const expired = await isTokenExpired();
    
    if (expired) {
      next({ name: "logout" });
    } else {
      protectRoutesUsingPermissions(to, next);
      next();
    }
  }
};

export default authMiddleware;
